<template>
  <section class="border-t border-default/60 bg-primary/5">
    <UContainer class="py-12 text-center sm:py-14">
      <h2 v-if="title" class="text-xl font-semibold text-highlighted sm:text-2xl">
        {{ title }}
      </h2>
      <p v-if="subtitle" class="mx-auto mt-2 max-w-lg text-sm text-muted sm:text-base">
        {{ subtitle }}
      </p>
      <div class="mt-6 flex flex-wrap justify-center gap-3">
        <UButton
          v-if="primaryLabel"
          :to="builderPreview ? undefined : primaryLink"
          size="lg"
          color="primary"
          trailing-icon="i-heroicons-calendar-days"
          :label="primaryLabel"
          @click="builderPreview ? navigate(primaryLink) : undefined"
        />
        <UButton
          v-if="secondaryLabel"
          :to="builderPreview ? undefined : secondaryLink"
          size="lg"
          color="neutral"
          variant="soft"
          :label="secondaryLabel"
          @click="builderPreview ? navigate(secondaryLink) : undefined"
        />
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  title?: string
  subtitle?: string
  primaryLabel?: string
  primaryLink?: string
  secondaryLabel?: string
  secondaryLink?: string
  builderPreview?: boolean
  onNavigate?: (to: string) => void
}>()

const primaryLink = computed(() => props.primaryLink || '/booking')
const secondaryLink = computed(() => props.secondaryLink || '/services')

function navigate(to?: string) {
  if (!to || !props.builderPreview || !props.onNavigate) return
  props.onNavigate(to)
}
</script>
